// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./info.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  --btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  --btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
  --dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;
}

.error {
  position: absolute;
  white-space: nowrap;
  max-height: 1.4em;
  top: 1.5em;
  font-weight: 400;
  font-size: 0.9em;
  color: rgba(124, 35, 35, 0.593);
  z-index: 1;
}
.error__date {
  margin-left: 0;
}
.error__hidden {
  z-index: -1000;
  margin-top: -4px;
}
.error_dateInp {
  top: 2em;
}

input {
  color: #426ba6;
  padding: 1px 0.5em;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #e2e2e2;
  font-style: italic;
  font-weight: 400;
}
input::placeholder {
  color: #a3b9d9;
  text-align: right;
}
input:focus {
  outline: none;
  border-bottom: 1px solid rgba(29, 38, 82, 0.3921568627);
}

.country_btn {
  border: 0;
  background: transparent;
}
.country_btn:hover {
  background: transparent;
}

.project_input {
  display: flex;
  align-items: baseline;
  justify-content: left;
  padding-top: 5px;
  position: relative;
}
.project_input.phoneInput .form-control {
  height: 1.3em;
  font-size: 1rem;
}
.project_input .react-tel-input .flag-dropdown {
  border: 0;
}
.project_input .react-tel-input .flag-dropdown:hover {
  background: transparent;
}
.project_input .inputSelect {
  position: absolute;
  list-style: none;
  padding: 0;
  background-color: rgba(255, 255, 255, 0.9215686275);
  border: 1px solid #a3b9d9;
  z-index: 2;
  max-height: 500px;
  max-width: 300px;
  overflow: auto;
}
.project_input .inputSelect li {
  padding: 5px;
  width: 150px;
}
.project_input .inputSelect li:hover {
  background-color: rgba(214, 223, 234, 0.5764705882);
  cursor: pointer;
}
.project_input label {
  text-align: left;
}
.project_input input {
  width: 100%;
  height: 1.3em;
  font-size: 1em;
  box-sizing: border-box;
  padding-left: 0.5em;
}
.project_input .select__list_button {
  cursor: pointer;
}
.project_input .select__list_container {
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  z-index: 300;
}
.project_input .select__list {
  position: absolute;
  background: rgb(255, 255, 255);
  opacity: 100%;
  border: 1px solid #8aa1c1;
  width: max-content;
  min-width: 100%;
  right: 0;
  top: 1.1em;
  padding: 0 0;
  z-index: 300;
  box-shadow: rgba(0, 0, 0, 0.118) 0px 19px 38px, rgba(0, 0, 0, 0.09) 0px 15px 12px;
  outline: none;
}
.project_input .select__list .optionListHeader {
  padding: 5px 0;
  text-align: center;
  cursor: default;
}
.project_input .select__list .optionListHeader:hover {
  background-color: transparent;
}
.project_input .select__list ul {
  background-color: #fff;
  margin: 0 0;
  max-height: 12em;
  overflow-y: auto;
  overflow-x: hidden;
  list-style: none;
  padding: 0 0;
  text-align: left;
  padding-bottom: 0.8em;
  padding-top: 0.3em;
}
.project_input .select__list ul:focus {
  border: 1px solid #8aa1c1;
  outline: none;
}
.project_input .select__list ul li {
  padding: 0.35em 0;
  padding-right: 0.35em;
  padding-left: 0.3em;
  font-weight: 400;
  border-bottom: 1px solid rgba(71, 74, 78, 0.0941176471);
  cursor: pointer;
}
.project_input .select__list ul li:last-child {
  border-bottom: 0;
}
.project_input .select__list ul li:hover {
  background-color: rgba(66, 108, 166, 0.1843137255);
}
.project_input .select__list ul li.select_li_disabled {
  background-color: rgba(247, 242, 242, 0.37);
  color: rgb(136, 136, 136);
  cursor: not-allowed;
  pointer-events: none;
}
.project_input.textereaInput {
  flex-direction: column;
  margin-top: 0;
  height: 70px;
  width: 100%;
}
.project_input.textereaInput ::placeholder {
  color: #a3b9d9;
}
.project_input .outlined input {
  border: 1px solid #e2e2e2;
  background: white;
  height: 1.5em;
}
.project_input .outlined.readOnly input {
  background: transparent;
}
.project_input .outlined.blue input {
  border: 1px solid #a3b9d9;
  background: white;
  height: 2em;
}
.project_input .outlined.blue_readonly input {
  border: 1px solid #a3b9d9;
  background: transparent;
  height: 2em;
}
.project_input .alingRight {
  text-align: right;
}

.outlined input {
  border: 1px solid #e2e2e2;
  background: white;
  height: 1.5em;
}
.outlined.readOnly input {
  background: transparent;
}
.outlined.blue input {
  border: 1px solid #a3b9d9;
  background: white;
  height: 2em;
}
.outlined.blue_readonly input {
  border: 1px solid #a3b9d9;
  background: transparent;
  height: 2em;
}

.left-drop .select__list {
  right: auto;
  left: 0;
}

.select__list.select__list--above {
  bottom: 14px;
  right: 0;
  top: unset;
}

.select__list.select__list--left {
  right: unset;
}

.selected_option {
  background-color: rgba(66, 108, 166, 0.1843137255);
}

.select_option.default_option {
  background-color: rgba(66, 108, 166, 0.65);
  color: white;
}
.select_option.default_option:hover, .select_option.default_option:focus {
  color: rgba(66, 108, 166, 0.8);
}

.accentedSelect {
  color: #b72025;
}

textarea {
  resize: none;
  width: 330px;
  height: 100%;
  border: 1px solid rgba(163, 185, 217, 0.5960784314);
  font-style: italic;
  font-weight: 400;
  font-size: 1rem;
  color: #426ba6;
}
textarea:focus {
  outline: none;
  border: 1px solid rgba(39, 51, 110, 0.4274509804);
}
textarea[readOnly]:focus {
  outline: none;
  border: 1px solid rgba(163, 185, 217, 0.5960784314);
}

.textArea_label {
  margin-bottom: 2px;
  white-space: nowrap;
}

.inputWithMeasureUnits {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}

.readOnly input:focus {
  outline: none;
  border-bottom: 1px solid #e2e2e2;
}

input[readOnly]:focus {
  outline: none;
  border-bottom: 1px solid #e2e2e2;
}

#questionImg {
  width: 1.2em;
  height: 1.2em;
  z-index: 99;
  display: block;
  position: relative;
}

.question {
  margin-left: 4px;
  position: relative;
  display: inline-block;
}
.question__dropdown {
  position: absolute;
  bottom: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  min-width: 100px;
  min-height: 10px;
  background-color: transparent;
  font-weight: 300;
  margin-left: -45px;
}
.question__dropdown p {
  padding: 0 5px;
  padding-bottom: 10px;
}

.procent {
  display: flex;
  align-items: flex-end;
  justify-content: right;
}
.procent:after {
  content: "%";
}

.price_input {
  display: flex;
  gap: 1em;
  align-items: flex-end;
}

.datePicker_withText {
  position: relative;
  display: flex;
  height: 1.5em;
}
.datePicker_withText input {
  color: #426ba6;
  z-index: 2;
  position: relative;
  padding: 0;
  background-color: rgba(255, 255, 255, 0);
}
.datePicker_withText input::placeholder {
  text-align: left;
}
.datePicker_withText input[type=date]::-webkit-calendar-picker-indicator {
  opacity: 0;
}
.datePicker_withText .datePicker_img {
  top: -0.3em;
  right: -0.4em;
  z-index: 99;
  cursor: pointer;
  position: absolute;
}

.question-date {
  left: 0;
  top: -4px;
  z-index: 99;
  cursor: pointer;
  position: relative;
}

.miniLabel label {
  width: 10px;
}

.additional_inputs {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1em;
}
.additional_inputs .project_input {
  min-width: 50px;
}
.additional_inputs label {
  width: auto;
}

.additional_inputs--reverse {
  margin-left: auto;
}

.closeInput label {
  width: auto;
  margin-right: 0.5em;
}

.question__dropdown {
  font-size: smaller;
}

input[type=checkbox] {
  width: 1.2em;
  height: 1.2em;
}

.doc__input_selected {
  border-bottom: 1px solid rgba(29, 38, 82, 0.3921568627);
}

.selectedFormRef .ref_input {
  border-bottom: 1px solid rgba(29, 38, 82, 0.3921568627);
}

.autolabel .project_input label {
  min-width: auto;
  width: auto;
  white-space: nowrap;
}

.project_input label.autolabel {
  min-width: auto;
  width: auto;
  white-space: nowrap;
}

.inputNoArrows::-webkit-outer-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  margin: 0;
}
.inputNoArrows::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  margin: 0;
}

.leftPlaceholder::placeholder {
  text-align: left;
}

.select__list_button-responsive {
  transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}
.select__list_button-responsive:active {
  transform: scale(0.9);
}`, "",{"version":3,"sources":["webpack://./src/Components/App/vars.scss","webpack://./src/Components/Inputs/utils/Inputs.scss","webpack://./src/Components/App/mixins.scss"],"names":[],"mappings":"AA8CA;EACE,sDAAA;EACA,0DAAA;EACA,2GAAA;EACA,kDAAA;AC7CF;;AADA;EACE,kBAAA;EAEA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;EACA,UAAA;AAGF;AAFE;EACE,cAAA;AAIJ;AAFE;EACE,cAAA;EACA,gBAAA;AAIJ;AAFE;EACE,QAAA;AAIJ;;AAAA;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AAGF;AAFE;EACE,cD/Be;ECgCf,iBAAA;AAIJ;AAFE;EACE,aAAA;EACA,uDAAA;AAIJ;;AADA;EACE,SAAA;EACA,uBAAA;AAIF;AAHE;EAEE,uBAAA;AAIJ;;AAAA;EACE,aAAA;EAEA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAEF;AACI;EACE,aAAA;EACA,eAAA;AACN;AAGE;EACE,SAAA;AADJ;AAEI;EAEE,uBAAA;AADN;AAKE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,mDDlDiB;EEkFnB,yBAAA;ED9BE,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAHJ;AAKI;EACE,YAAA;EACA,YAAA;AAHN;AAKM;EACE,mDD7DkB;EC8DlB,eAAA;AAHR;AAQE;EACE,gBAAA;AANJ;AAaE;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AAXJ;AAeI;EACE,eAAA;AAbN;AAeI;EAEE,WAAA;EAEA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AAfN;AAiBI;EACE,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,yBAAA;EAEA,kBAAA;EACA,eAAA;EACA,QAAA;EAEA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iFAAA;EACA,aAAA;AAjBN;AAmBM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AAjBR;AAmBQ;EACE,6BAAA;AAjBV;AAqBM;EACE,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AAnBR;AAoBQ;EACE,yBAAA;EACA,aAAA;AAlBV;AAqBQ;EACE,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,uDAAA;EACA,eAAA;AApBV;AAqBU;EACE,gBAAA;AAnBZ;AAqBU;EAEE,kDAAA;AApBZ;AAsBU;EACE,2CAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;AApBZ;AA2BE;EACE,sBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AAzBJ;AA2BI;EACE,cDrMa;AC4KnB;AA8BI;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;AA5BN;AA+BM;EACE,uBAAA;AA7BR;AAkCM;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;AAhCR;AAqCM;EACE,yBAAA;EACA,uBAAA;EACA,WAAA;AAnCR;AAuCE;EACE,iBAAA;AArCJ;;AA0CE;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;AAvCJ;AA0CI;EACE,uBAAA;AAxCN;AA6CI;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;AA3CN;AAgDI;EACE,yBAAA;EACA,uBAAA;EACA,WAAA;AA9CN;;AAoDE;EACE,WAAA;EACA,OAAA;AAjDJ;;AAoDA;EACE,YAAA;EACA,QAAA;EACA,UAAA;AAjDF;;AAmDA;EAEE,YAAA;AAjDF;;AAoDA;EACE,kDAAA;AAjDF;;AAmDA;EACE,0CAAA;EACA,YAAA;AAhDF;AAkDE;EAEE,8BAAA;AAjDJ;;AAoDA;EACE,cDhSY;AC+Od;;AAoDA;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAGA,cAAA;AAnDF;AAoDE;EACE,aAAA;EACA,iDAAA;AAlDJ;AAqDI;EACE,aAAA;EACA,mDAAA;AAnDN;;AAuDA;EACE,kBAAA;EACA,mBAAA;AApDF;;AAsDA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAnDF;;AAwDI;EACE,aAAA;EACA,gCAAA;AArDN;;AA0DE;EACE,aAAA;EACA,gCAAA;AAvDJ;;AA2DA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AAxDF;;AA0DA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;AAvDF;AAyDE;EACE,kBAAA;EACA,YAAA;EACA,yDAvWK;EAwWL,4BAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AAvDJ;AAwDI;EACE,cAAA;EACA,oBAAA;AAtDN;;AA2DA;EACE,aAAA;EACA,qBAAA;EACA,sBAAA;AAxDF;AA6DE;EAIE,YAAA;AA9DJ;;AAkEA;EACE,aAAA;EACA,QAAA;EACA,qBAAA;AA/DF;;AAkEA;EACE,kBAAA;EACA,aAAA;EAEA,aAAA;AAhEF;AAmEE;EAGE,cAAA;EACA,UAAA;EACA,kBAAA;EAGA,UAAA;EAEA,wCAAA;AAtEJ;AA2EI;EACE,gBAAA;AAzEN;AA4EE;EACE,UAAA;AA1EJ;AA6EE;EAEE,WAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA5EJ;;AAgFA;EACE,OAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA7EF;;AAiFE;EACE,WAAA;AA9EJ;;AAiFA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,QAAA;AA9EF;AAgFE;EACE,eAAA;AA9EJ;AAkFE;EACE,WAAA;AAhFJ;;AAmFA;EACE,iBAAA;AAhFF;;AAoFE;EACE,WAAA;EACA,mBAAA;AAjFJ;;AAoFA;EACE,kBAAA;AAjFF;;AAoFA;EACE,YAAA;EACA,aAAA;AAjFF;;AAoFA;EAEE,uDAAA;AAlFF;;AAyFE;EACE,uDAAA;AAtFJ;;AA2FE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAxFJ;;AA6FE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AA1FJ;;AA8FE;EACE,gBAAA;EACA,wBAAA;EACA,0BAAA;EACA,SAAA;AA3FJ;AA6FE;EACE,gBAAA;EACA,wBAAA;EACA,0BAAA;EACA,SAAA;AA3FJ;;AA+FA;EACE,gBAAA;AA5FF;;AA+FA;EACE,wDAAA;AA5FF;AA8FE;EACE,qBAAA;AA5FJ","sourcesContent":["$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$borderColorLight: #dae1ec;\n$accentFilterColor: #ff8040;\n$accentColor: #b72025;\n$warningColor: #d3c71c;\n$succesColor: #00dbbb;\n$accentTableRowColor: #ecc0c1;\n$filtersBgColor: #d6dfea71; //#d6dfea\n$filterTitleColor: #d6dfea93;\n$textColor: #426ba6;\n$filtersBorderColor: #426ba6;\n$deletedTextColor: #b72025;\n$iconFill: #829ec4;\n$logoIcon: #6d91c6;\n$activeBtnColor: rgba(218, 225, 236, 1);\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n$btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;\n$reactTableShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;\n$dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;\n$commonShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$commonShadowHover: rgba(67, 71, 85, 0.27) 1px 1px 0.25em, rgba(90, 125, 188, 0.05) 1px 0.3em 1em;\n\n$transition: ease;\n$transitionFunc: cubic-bezier(0.25, 1, 0.5, 1);\n$iconHoverTransition: cubic-bezier(0.22, 1, 0.36, 1);\n$commonTransition: 0.3s $transitionFunc;\n\n:root {\n  --filterBtnBoxShadow: #{$filterBtnBoxShadow};\n  --btnBoxShadow: #{$btnBoxShadow};\n  --btnHoverBoxShadow: #{$btnHoverBoxShadow};\n  --dividerShadow: #{$dividerShadow};\n}\n\n$main-font: \"Roboto\", sans-serif;\n\n$font-weights: (\n  \"Light\": 300,\n  \"Regular\": 400,\n  \"Medium\": 500,\n  \"Bold\": 700,\n);\n","@import \"../../App/vars.scss\";\n@import \"../../App/mixins.scss\";\n\n$bg-img: url(\"./info.png\");\n.error {\n  position: absolute;\n  // width: 100%;\n  white-space: nowrap;\n  max-height: 1.4em;\n  top: 1.5em;\n  font-weight: 400;\n  font-size: 0.9em;\n  color: rgba(124, 35, 35, 0.593);\n  z-index: 1;\n  &__date {\n    margin-left: 0;\n  }\n  &__hidden {\n    z-index: -1000;\n    margin-top: -4px;\n  }\n  &_dateInp {\n    top: 2em;\n  }\n}\n\ninput {\n  color: #426ba6;\n  padding: 1px 0.5em;\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid #e2e2e2;\n  font-style: italic;\n  font-weight: 400;\n  &::placeholder {\n    color: $placeholderColor;\n    text-align: right;\n  }\n  &:focus {\n    outline: none;\n    border-bottom: 1px solid #1d265264;\n  }\n}\n.country_btn {\n  border: 0;\n  background: transparent;\n  &:hover {\n    // font-weight: 500;\n    background: transparent;\n  }\n}\n\n.project_input {\n  display: flex;\n  // align-items: flex-start;\n  align-items: baseline;\n  justify-content: left;\n  padding-top: 5px;\n  position: relative;\n\n  &.phoneInput {\n    & .form-control {\n      height: 1.3em;\n      font-size: 1rem;\n    }\n  }\n\n  .react-tel-input .flag-dropdown {\n    border: 0;\n    &:hover {\n      // font-weight: 500;\n      background: transparent;\n    }\n  }\n\n  & .inputSelect {\n    position: absolute;\n    list-style: none;\n    padding: 0;\n    background-color: $inputSelectBgColor;\n    @include border;\n    z-index: 2;\n    max-height: 500px;\n    max-width: 300px;\n    overflow: auto;\n\n    & li {\n      padding: 5px;\n      width: 150px;\n\n      &:hover {\n        background-color: $inputSelectHoverBgColor;\n        cursor: pointer;\n      }\n    }\n  }\n\n  label {\n    text-align: left;\n    // margin-top: 5px;\n    // margin-right: 5px;\n\n    // min-width: 7em;\n  }\n\n  input {\n    width: 100%;\n    height: 1.3em;\n    font-size: 1em;\n    box-sizing: border-box;\n    padding-left: 0.5em;\n  }\n\n  .select {\n    &__list_button {\n      cursor: pointer;\n    }\n    &__list_container {\n      // width: 25%;\n      width: 100%;\n      // width: calc(100% + 3em);\n      height: 100%;\n      display: flex;\n      position: absolute;\n      z-index: 300;\n    }\n    &__list {\n      position: absolute;\n      background: rgb(255, 255, 255);\n      opacity: 100%;\n      border: 1px solid #8aa1c1;\n      // min-width: 60%;\n      width: max-content;\n      min-width: 100%;\n      right: 0;\n      // width: calc(100% + 3em);\n      top: 1.1em;\n      padding: 0 0;\n      z-index: 300;\n      box-shadow: rgba(0, 0, 0, 0.118) 0px 19px 38px, rgba(0, 0, 0, 0.09) 0px 15px 12px;\n      outline: none;\n\n      .optionListHeader {\n        padding: 5px 0;\n        text-align: center;\n        cursor: default;\n\n        &:hover {\n          background-color: transparent;\n        }\n      }\n\n      ul {\n        background-color: #fff;\n        margin: 0 0;\n        max-height: 12em;\n        overflow-y: auto;\n        overflow-x: hidden;\n        list-style: none;\n        padding: 0 0;\n        text-align: left;\n        padding-bottom: 0.8em;\n        padding-top: 0.3em;\n        &:focus {\n          border: 1px solid #8aa1c1;\n          outline: none;\n        }\n\n        li {\n          padding: 0.35em 0;\n          padding-right: 0.35em;\n          padding-left: 0.3em;\n          font-weight: 400;\n          // margin-top: 0.3em;\n          border-bottom: 1px solid #474a4e18;\n          cursor: pointer;\n          &:last-child {\n            border-bottom: 0;\n          }\n          &:hover {\n            // font-weight: 500;\n            background-color: rgba(66, 108, 166, 0.1843137255);\n          }\n          &.select_li_disabled {\n            background-color: rgba(247, 242, 242, 0.37);\n            color: rgb(136, 136, 136);\n            cursor: not-allowed;\n            pointer-events: none;\n          }\n        }\n      }\n    }\n  }\n\n  &.textereaInput {\n    flex-direction: column;\n    margin-top: 0;\n    height: 70px;\n    width: 100%;\n\n    ::placeholder {\n      color: $placeholderColor;\n    }\n  }\n\n  .outlined {\n    input {\n      border: 1px solid #e2e2e2;\n      background: white;\n      height: 1.5em;\n    }\n    &.readOnly {\n      input {\n        background: transparent;\n      }\n    }\n\n    &.blue {\n      input {\n        border: 1px solid #a3b9d9;\n        background: white;\n        height: 2em;\n      }\n    }\n\n    &.blue_readonly {\n      input {\n        border: 1px solid #a3b9d9;\n        background: transparent;\n        height: 2em;\n      }\n    }\n  }\n  .alingRight {\n    text-align: right;\n  }\n}\n\n.outlined {\n  input {\n    border: 1px solid #e2e2e2;\n    background: white;\n    height: 1.5em;\n  }\n  &.readOnly {\n    input {\n      background: transparent;\n    }\n  }\n\n  &.blue {\n    input {\n      border: 1px solid #a3b9d9;\n      background: white;\n      height: 2em;\n    }\n  }\n\n  &.blue_readonly {\n    input {\n      border: 1px solid #a3b9d9;\n      background: transparent;\n      height: 2em;\n    }\n  }\n}\n\n.left-drop {\n  .select__list {\n    right: auto;\n    left: 0;\n  }\n}\n.select__list.select__list--above {\n  bottom: 14px;\n  right: 0;\n  top: unset;\n}\n.select__list.select__list--left {\n  // bottom: 16px;\n  right: unset;\n  // top: unset;\n}\n.selected_option {\n  background-color: rgba(66, 108, 166, 0.1843137255);\n}\n.select_option.default_option {\n  background-color: rgba(66, 108, 166, 0.65);\n  color: white;\n\n  &:hover,\n  &:focus {\n    color: rgba(66, 108, 166, 0.8);\n  }\n}\n.accentedSelect {\n  color: $accentColor;\n}\n\ntextarea {\n  resize: none;\n  width: 330px;\n  height: 100%;\n  border: 1px solid #a3b9d998;\n  font-style: italic;\n  font-weight: 400;\n  font-size: 1rem;\n  // font-size: 0.9em;\n  // line-height: 13px;\n  color: #426ba6;\n  &:focus {\n    outline: none;\n    border: 1px solid #27336e6d;\n  }\n  &[readOnly] {\n    &:focus {\n      outline: none;\n      border: 1px solid #a3b9d998;\n    }\n  }\n}\n.textArea_label {\n  margin-bottom: 2px;\n  white-space: nowrap;\n}\n.inputWithMeasureUnits {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.readOnly {\n  input {\n    &:focus {\n      outline: none;\n      border-bottom: 1px solid #e2e2e2;\n    }\n  }\n}\ninput[readOnly] {\n  &:focus {\n    outline: none;\n    border-bottom: 1px solid #e2e2e2;\n  }\n}\n\n#questionImg {\n  width: 1.2em;\n  height: 1.2em;\n  z-index: 99;\n  display: block;\n  position: relative;\n}\n.question {\n  margin-left: 4px;\n  position: relative;\n  display: inline-block;\n\n  &__dropdown {\n    position: absolute;\n    bottom: 20px;\n    background-image: $bg-img;\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    min-width: 100px;\n    min-height: 10px;\n    background-color: transparent;\n    font-weight: 300;\n    margin-left: -45px;\n    p {\n      padding: 0 5px;\n      padding-bottom: 10px;\n    }\n  }\n}\n\n.procent {\n  display: flex;\n  align-items: flex-end;\n  justify-content: right;\n  // margin-left: 4px;\n  // position: relative;\n  // display: inline-block;\n  // position: relative;\n  &:after {\n    // margin-left: 4px;\n    // position: relative;\n    // display: inline-block;\n    content: \"%\";\n  }\n}\n\n.price_input {\n  display: flex;\n  gap: 1em;\n  align-items: flex-end;\n}\n\n.datePicker_withText {\n  position: relative;\n  display: flex;\n  // align-items: center;\n  height: 1.5em;\n  // width: 9em;\n  // width: 160px;\n  input {\n    // left: -100px;\n    // top: 0.3em;\n    color: #426ba6;\n    z-index: 2;\n    position: relative;\n    // width: 100px;\n    // height: 15px;\n    padding: 0;\n    // border: 0;\n    background-color: rgba(255, 255, 255, 0);\n    // &:focus {\n    //     outline: none;\n    //     // border-bottom: 0;\n    // }\n    &::placeholder {\n      text-align: left;\n    }\n  }\n  input[type=\"date\"]::-webkit-calendar-picker-indicator {\n    opacity: 0;\n    // cursor: pointer;\n  }\n  .datePicker_img {\n    // left: -1.5em;\n    top: -0.3em;\n    right: -0.4em;\n    z-index: 99;\n    cursor: pointer;\n    position: absolute;\n  }\n}\n\n.question-date {\n  left: 0;\n  top: -4px;\n  z-index: 99;\n  cursor: pointer;\n  position: relative;\n}\n\n.miniLabel {\n  label {\n    width: 10px;\n  }\n}\n.additional_inputs {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 1em;\n  // width: 100%;\n  .project_input {\n    min-width: 50px;\n    // max-width: 70px;\n  }\n\n  label {\n    width: auto;\n  }\n}\n.additional_inputs--reverse {\n  margin-left: auto;\n}\n\n.closeInput {\n  label {\n    width: auto;\n    margin-right: 0.5em;\n  }\n}\n.question__dropdown {\n  font-size: smaller;\n}\n\ninput[type=\"checkbox\"] {\n  width: 1.2em;\n  height: 1.2em;\n}\n\n.doc__input_selected {\n  // outline: none;\n  border-bottom: 1px solid #1d265264;\n  // background-color:#426ca619;\n  // background: linear-gradient( transparent, 70%, #426ca621);\n  // background: radial-gradient(at 30% 100%, #426ca621 30%, transparent 70%);\n}\n\n.selectedFormRef {\n  .ref_input {\n    border-bottom: 1px solid #1d265264;\n  }\n}\n\n.autolabel {\n  .project_input label {\n    min-width: auto;\n    width: auto;\n    white-space: nowrap;\n  }\n}\n\n.project_input {\n  label.autolabel {\n    min-width: auto;\n    width: auto;\n    white-space: nowrap;\n  }\n}\n.inputNoArrows {\n  &::-webkit-outer-spin-button {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: textfield;\n    margin: 0;\n  }\n  &::-webkit-inner-spin-button {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: textfield;\n    margin: 0;\n  }\n}\n\n.leftPlaceholder::placeholder {\n  text-align: left;\n}\n\n.select__list_button-responsive {\n  transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1);\n\n  &:active {\n    transform: scale(0.9);\n  }\n}\n","//flex\n@mixin flex($gap: 0) {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: $gap;\n}\n\n@mixin flexCenter($gap: 0) {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: $gap;\n}\n\n@mixin flexStart {\n  display: flex;\n  justify-content: flex-start;\n  align-items: baseline;\n}\n\n@mixin flexSpB {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n@mixin flexBslnSpcBtwn {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n}\n\n@mixin flexColumn($gap: 0) {\n  display: flex;\n  flex-direction: column;\n  gap: $gap;\n}\n\n@mixin twoColumnsMain {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 5px;\n\n  & > :first-child,\n  & > :last-child {\n    flex-shrink: 0;\n  }\n\n  & > :first-child {\n    width: 51%;\n    padding-right: 7px;\n    @include borderR;\n  }\n\n  & > :last-child {\n    width: 50%;\n    padding-left: 7px;\n  }\n}\n\n@mixin twoColumnsRow($first: 50%, $second: 50%) {\n  display: flex;\n  justify-content: space-between;\n\n  & > :first-child,\n  & > :last-child {\n    flex-shrink: 0;\n  }\n\n  & > :first-child {\n    width: $first;\n  }\n\n  & > :last-child {\n    width: $second;\n  }\n}\n\n@mixin treeColumnsRow($first: 33%, $second: 33%, $third: 33%) {\n  display: flex;\n  justify-content: space-between;\n\n  & > :first-child,\n  & > :nth-child(2),\n  & > :last-child {\n    flex-shrink: 0;\n  }\n\n  & > :first-child {\n    width: $first;\n  }\n\n  & > :nth-child(2) {\n    width: $second;\n  }\n\n  & > :last-child {\n    width: $third;\n  }\n}\n\n//general\n@mixin centerElement {\n  margin-left: 50%;\n  position: relative;\n  transform: translate(-50%, 0);\n}\n\n@mixin border {\n  border: 1px solid $borderColor;\n}\n\n@mixin borderT {\n  border-top: 1px solid $borderColor;\n}\n\n@mixin borderL {\n  border-left: 1px solid $borderColor;\n}\n\n@mixin borderR {\n  border-right: 1px solid $borderColor;\n}\n\n@mixin borderB {\n  border-bottom: 1px solid $borderColor;\n}\n\n@mixin middleBottom {\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: auto;\n}\n\n@mixin sectionHeader {\n  font-family: Roboto;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n@mixin centerH {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n//clean styles\n@mixin cleanButton {\n  border: 0;\n  margin: 0;\n  padding: 0;\n  display: block;\n  color: inherit;\n}\n\n@mixin cleanList {\n  list-style: none;\n  padding-left: 0;\n}\n\n@mixin cleanHeader {\n  color: inherit;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-weight: inherit;\n  font-size: inherit;\n}\n\n@mixin min-width($width) {\n  @media (min-width: $width) {\n    @content;\n  }\n}\n@mixin max-width($width) {\n  @media (max-width: $width) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
